<template>
  <div class="row m-0">
    <div class="col-sm-6 content-wrapper">
    <div class="address-info">
      <div class="address-text">{{ address.address }}</div>
      <div class="address-city">
        <strong>City:</strong> {{ address.city }} | <strong>Post Code:</strong> {{ address.post_code }}
      </div>
      <div class="address-dates">

        <span><strong>From:</strong> {{ dateFormatter(address.from_date) }}</span>
        <span><strong>To:</strong> {{ dateFormatter(address.to_date) }}</span>
      </div>
      </div>
    </div>

    <div class="col-sm-6 content-wrapper">
      <div class="form-group row">
        <el-button
            type="primary"
            size="small"
            @click="setIsShowStatus">
          {{ isShowStatus ? 'Hide Status' : 'Show Status' }}
        </el-button>
      </div>

      <div class="form-group row">
        <general-comments
            :comments="comment"
            :emailAddress="emailAddress"
            :applicantId="applicantId"
            :statusable_type="statusable_type"
            :statusable_id="statusable_id"
            :steps="this.steps"
            v-if="isShowStatus"
        />
      </div>
      <div class="form-group row">

        <comments-list v-if="showcommentToEdit"
                       :comment="commentToEdit"
                       :applicantId="applicantId"
                       :emailAddress="emailAddress"
                       @close-comment-listing="closeComment"
                       :steps="this.steps"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  dateFormatter
} from "@Views/Screening/utility/common";
import {_status, oralSteps, writtenSteps} from "@Views/Screening/utility/constant";
import {updateCommentSteps} from "@Views/Screening/utility/common/comment";

export default {
  name: "AddressComments",
  props: {
    address: {
      type: Object
    },
    applicantId: {
      type: Number
    },
    statusable_type: {
      type: String
    },
    statusable_id: {
      type: Number
    },
    emailAddress: {
      type: String
    },
    comment: {
      type: Array
    }
  },
  data() {
    return {
      steps: [],
      showcommentToEdit: false,
      commentToEdit: {},
      statusList: _status,
      oralSteps: oralSteps,
      writtenSteps: writtenSteps,
      isShowStatus: false
    }
  },
  created() {
    this.setStepsOnInitialization();
  },
  methods: {
    dateFormatter,
    updateCommentSteps,
    deleteNode(event) {
      const {data} = event.node;
      let index = data.index - 1;
      this.steps.splice(index, 1);
    },
    editNode(event) {
      this.commentToEdit = {};
      this.$set(this.commentToEdit, 'id', event.data.children[0].id);
      this.$set(this.commentToEdit, 'action_comment', event.data.children[0].action_comment);
      this.$set(this.commentToEdit, 'status', event.data.children[0].type);
      this.$set(this.commentToEdit, 'applicant_files', event.data.children[0].applicant_files);
      this.$set(this.commentToEdit, 'statusable_id', event.data.children[0].statusable_id);
      this.$set(this.commentToEdit, 'statusable_type', event.data.children[0].statusable_type);
      this.showcommentToEdit = true;
    },
    closeComment(event) {
      this.commentToEdit = {};
      this.showcommentToEdit = event;
    },
    setStepsOnInitialization() {
      for (const _comment of this.comment) {
        const o = {
          id : _comment.id,
          action_comment: _comment.action_comment,
          status: _comment.status,
          applicant_files: _comment.applicant_files,
          statusable_id : _comment.statusable_id,
          statusable_type : _comment.statusable_type
        };
        this.updateCommentSteps(o, true);
      }
    },
    setIsShowStatus() {
      this.isShowStatus = !this.isShowStatus;
    }
  }
}
</script>

<style scoped>
.address-info {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  border-left: 4px solid #28a745;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);
  font-family: Arial, sans-serif;
  max-width: 400px;
}

.address-text {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}

.address-city {
  font-size: 14px;
  color: #555;
  margin-bottom: 10px;
}

.address-dates {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: #666;
  margin-top: 5px;
}

.address-dates span {
  padding: 3px 0;
}

</style>